/**
 * @generated SignedSource<<9a9e62ca7026cb176df24389aae4d90b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type knowledgeSection_AtlassianConversationAssistantAgent_AgentKnowledgeSection_scenarioListRef$data = {
  readonly " $fragmentSpreads": FragmentRefs<"webSearchPill_AtlassianConversationAssistantAgent_WebSearchPillListDataComponent_scenarioListRef">;
  readonly " $fragmentType": "knowledgeSection_AtlassianConversationAssistantAgent_AgentKnowledgeSection_scenarioListRef";
};
export type knowledgeSection_AtlassianConversationAssistantAgent_AgentKnowledgeSection_scenarioListRef$key = {
  readonly " $data"?: knowledgeSection_AtlassianConversationAssistantAgent_AgentKnowledgeSection_scenarioListRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"knowledgeSection_AtlassianConversationAssistantAgent_AgentKnowledgeSection_scenarioListRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "knowledgeSection_AtlassianConversationAssistantAgent_AgentKnowledgeSection_scenarioListRef",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "webSearchPill_AtlassianConversationAssistantAgent_WebSearchPillListDataComponent_scenarioListRef"
    }
  ],
  "type": "AgentStudioScenariosResult"
};

(node as any).hash = "049c8405337ecb6851f9b9202cb98803";

export default node;
